// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locationsLogBlock__BclQE {
  width: 100%;
}
@media (max-width: 1200px) {
  .locationsLogBlock__BclQE {
    height: calc(45% - 30px);
  }
}

.locationsLogBlockTitle__B3LEZ {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  margin-bottom: 15px;
}

.locationsLogBlockContainer__heXPm {
  height: calc(100% - 30px);
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--basic-box-shadow);
  overflow: auto;
}
.locationsLogBlockContainer__heXPm::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.locationsLogBlockContainer__heXPm::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.locationsLogBlockContainer__heXPm::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.locationsLogBlockContainer__heXPm::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.locationsLogsTable__UiJck {
  width: 100%;
  background: var(--tables-primary-row-surface-default);
}
.locationsLogsTable__UiJck th {
  color: var(--tables-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  text-align: left;
  padding: 16px 15px;
  background: var(--tables-title-surface);
  border-bottom: 1px solid var(--tables-title-stroke);
  position: sticky;
  top: 0;
}
.locationsLogsTable__UiJck th:first-child {
  padding-left: 25px;
}
.locationsLogsTable__UiJck td {
  padding: 16px 15px;
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}
.locationsLogsTable__UiJck td:first-child {
  padding-left: 25px;
}

.locationsLogsTableBodyRow__OYbiQ td {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.locationsLogsTableBodyRow__OYbiQ:hover {
  background: var(--tables-primary-row-surface-hover);
}

.details__Ujhsp {
  color: var(--tables-primary-row-text-additional);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

.messageCell__FPdIo {
  max-width: 300px;
}

.dateTimeCell__xGuZq {
  text-transform: uppercase;
}

.userNameCell__vXaTu {
  color: var(--tables-primary-row-text-additional);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  margin-top: 5px;
}

@media (max-width: 1536px) {
  .hideColumn__mE4ni {
    display: none;
  }
}

.detailsInfo__oopp0 {
  max-width: 400px;
  margin-top: 5px;
}
@media (min-width: 1537px) {
  .detailsInfo__oopp0 {
    display: none;
  }
}

.skeletonText__lHJ0F {
  height: 23px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageLocations/components/LocationsLog/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;AAzEF;AA2EE;EAHF;IAII,wBAAA;EAxEF;AACF;;AA2EA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,yBAAA;EACA,qDAAA;EACA,mCAAA;EACA,cAAA;AAxEF;AAEE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAAJ;AAGE;EACE,+BAAA;EACA,kBAAA;AADJ;AAIE;EACE,8BAAA;EACA,kBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,kBAAA;AAHJ;;AA2DA;EACE,WAAA;EACA,qDAAA;AAxDF;AA0DE;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;EACA,mDAAA;EACA,gBAAA;EACA,MAAA;AAxDJ;AA0DI;EACE,kBAAA;AAxDN;AA4DE;EACE,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA1DJ;AA4DI;EACE,kBAAA;AA1DN;;AAgEE;EACE,yDAAA;AA7DJ;AAgEE;EACE,mDAAA;AA9DJ;;AAkEA;EACE,gDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA/DF;;AAkEA;EACE,gBAAA;AA/DF;;AAkEA;EACE,yBAAA;AA/DF;;AAkEA;EACE,gDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA/DF;;AAmEE;EADF;IAEI,aAAA;EA/DF;AACF;;AAkEA;EACE,gBAAA;EACA,eAAA;AA/DF;AAiEE;EAJF;IAKI,aAAA;EA9DF;AACF;;AAiEA;EACE,YAAA;AA9DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.locationsLogBlock {\n  width: 100%;\n\n  @media (max-width: 1200px) {\n    height: calc(45% - 30px);\n  }\n}\n\n.locationsLogBlockTitle {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  margin-bottom: 15px;\n}\n\n.locationsLogBlockContainer {\n  height: calc(100% - 30px);\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--basic-box-shadow);\n  overflow: auto;\n  @include scrollBar;\n}\n\n.locationsLogsTable {\n  width: 100%;\n  background: var(--tables-primary-row-surface-default);\n\n  th {\n    color: var(--tables-title-text);\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: uppercase;\n    text-align: left;\n    padding: 16px 15px;\n    background: var(--tables-title-surface);\n    border-bottom: 1px solid var(--tables-title-stroke);\n    position: sticky;\n    top: 0;\n\n    &:first-child {\n      padding-left: 25px;\n    }\n  }\n\n  td {\n    padding: 16px 15px;\n    color: var(--tables-primary-row-text-main);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n\n    &:first-child {\n      padding-left: 25px;\n    }\n  }\n}\n\n.locationsLogsTableBodyRow {\n  td {\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n  }\n\n  &:hover {\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.details {\n  color: var(--tables-primary-row-text-additional);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n}\n\n.messageCell {\n  max-width: 300px;\n}\n\n.dateTimeCell {\n  text-transform: uppercase;\n}\n\n.userNameCell {\n  color: var(--tables-primary-row-text-additional);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  margin-top: 5px;\n}\n\n.hideColumn {\n  @media (max-width: 1536px) {\n    display: none;\n  }\n}\n\n.detailsInfo {\n  max-width: 400px;\n  margin-top: 5px;\n\n  @media (min-width: 1537px) {\n    display: none;\n  }\n}\n\n.skeletonText {\n  height: 23px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationsLogBlock": `locationsLogBlock__BclQE`,
	"locationsLogBlockTitle": `locationsLogBlockTitle__B3LEZ`,
	"locationsLogBlockContainer": `locationsLogBlockContainer__heXPm`,
	"locationsLogsTable": `locationsLogsTable__UiJck`,
	"locationsLogsTableBodyRow": `locationsLogsTableBodyRow__OYbiQ`,
	"details": `details__Ujhsp`,
	"messageCell": `messageCell__FPdIo`,
	"dateTimeCell": `dateTimeCell__xGuZq`,
	"userNameCell": `userNameCell__vXaTu`,
	"hideColumn": `hideColumn__mE4ni`,
	"detailsInfo": `detailsInfo__oopp0`,
	"skeletonText": `skeletonText__lHJ0F`
};
module.exports = ___CSS_LOADER_EXPORT___;
